import Constant from '@/const';
import axios from 'axios';

const getPharmacyPatientByCategory = async params => {
  try {
    const response = await axios.get(
      Constant.apiUrl.concat(`/pharmacy/category/${params.category}`),
      { params },
    );
    return response;
  } catch (error) {
    throw new Error(error);
  }
};

export default getPharmacyPatientByCategory;
